import React from "react";
import { useTranslation } from "react-i18next";
import AppCheckbox from "components/ui/AppCheckbox";
import AppPaginatedTable from "components/ui/AppPaginatedTable";
import AppTag from "components/ui/AppTag";

const GroupModiferTable = ({
  showAttachButton = true,
  showActionButton = true,
  customizations,
  selectedCustomizations,
  toBeUnLinkCustomizations = [],
  actionButtons = () => {},
  setSelectedCustomizations = () => {},
  setToBeUnLinkCustomizations = () => {},
  height = "70vh",
}) => {
  const { t } = useTranslation();

  const handleSelectAllCustomizations = () => {
    if (selectedCustomizations?.length === customizations?.length) {
      setSelectedCustomizations([]);
      setToBeUnLinkCustomizations(customizations);
    } else {
      setSelectedCustomizations(customizations);
      setToBeUnLinkCustomizations([]);
    }
  };

  const handleSelectCustomization = (customization) => {
    if (selectedCustomizations?.some((row) => row._id === customization?._id)) {
      setSelectedCustomizations(
        selectedCustomizations.filter((row) => row._id !== customization?._id)
      );
      if(!toBeUnLinkCustomizations?.some((row) => row._id === customization?._id)) {
        setToBeUnLinkCustomizations(prevState => [...prevState, customization]);
      }
    } else {
      setSelectedCustomizations([...selectedCustomizations, customization]);
      setToBeUnLinkCustomizations(prevState => prevState.filter(m => m._id !== customization._id));
    }
  };

  const columns = [];
  if (showAttachButton) {
    columns.push({
      title: (
        <div>
          <AppCheckbox
            label={`${selectedCustomizations?.length} / ${customizations?.length}`}
            checked={selectedCustomizations?.length === customizations?.length}
            onChange={() => handleSelectAllCustomizations()}
          />
        </div>
      ),
      dataIndex: "_id",
      align: "center",
      render: (value, row, i) => {
        return (
          <AppCheckbox
            checked={
              selectedCustomizations.find((customization) => customization._id === row?._id)
                ? true
                : false
            }
            onChange={() => handleSelectCustomization(row)}
          />
        );
      },
    });
  }

  columns.push(
    ...[
      {
        title: t("Name"),
        dataIndex: "baseLanguage",
        key: "title",
        render: (value, row, i) => {
          return <div className="truncate-line-3">{value?.name}</div>;
        },
      },
      {
        title: t("Maximum Allowed Selection"),
        dataIndex: "maximumAllowedSelection",
        width: "100px",
        headerStyle: { whiteSpace: "break-spaces" },
        render: (value, row, i) => {
          return <div className="text-center w-full">{value}</div>;
        },
      },
      {
        title: t("Required"),
        dataIndex: "isRequired",
        headerClassName: "text-center",
        render: (value, row, i) => {
          return (
           <AppTag 
            variant={row?.isRequired ? "warning" : "neutral"}
            size="sm"
          >
            {row?.isRequired ? t("Yes") : t("No")}
          </AppTag>
        );
      },
    },
  ]);

  if (showActionButton) {
    columns.push([
      {
          title: t("Action"),
          fixed: "right",
          render:  actionButtons,
        },
      ]
    );
  }

  return (
    <div
      style={{ height: height }}
    >
      <AppPaginatedTable
        columns={columns}
        data={customizations}
        clientSidePagination={true}
        pageSize={10}
        total={customizations?.length}
      />
    </div>
  );
};

export default GroupModiferTable;
